import { useController, UseFormReturn } from 'react-hook-form'
import { Trans, useTranslation } from 'next-i18next'

import Checkbox from '@/components/form/Checkbox'

import { useMarket } from '@/utils/multi-markets/context'

import { SubscribersFormType } from '@/components/landing/type'

interface Props {
  form: UseFormReturn<SubscribersFormType>
}

function ConsentController(props: Props) {
  const { form } = props
  const { t } = useTranslation(['landing', 'common'])
  const { market } = useMarket()
  const { field, fieldState } = useController<SubscribersFormType, 'consent'>({
    control: form.control,
    name: 'consent',
    defaultValue: false,
    rules: {
      required: {
        value: true,
        message: t('common:form.errors.required')
      }
    }
  })

  const company = {
    pl: 'Naviparking Poland Sp. z o.o.',
    ae: 'NaviParking DMCC',
    bh: 'Naviparking MENA W.L.L'
  }[market]

  const consentShort = (
    <Trans
      t={t}
      i18nKey="landing:burjuman.form.consent.short"
      values={{ company }}
    />
  )

  const consentLong = (
    <Trans
      t={t}
      i18nKey="landing:burjuman.form.consent.long"
      values={{ company }}
    />
  )

  function handleChange(value: boolean) {
    field.onChange(value)
    form.trigger(field.name)
  }

  return (
    <Checkbox
      ref={field.ref}
      label={consentShort}
      labelLong={consentLong}
      value={field.value}
      error={fieldState.error?.message}
      onChange={handleChange}
      onBlur={field.onBlur}
      greenStyle
    />
  )
}

export default ConsentController
